import { Breadcrumbs } from "@/components/Breadcrumbs";
import clsx from "classnames";
import dynamic from "next/dynamic";
const Lottie = dynamic(() => import("lottie-react"), { ssr: false });
import { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./styles.module.scss";
import { useRouter } from "next/router";

const animations = {
  It_Works_Drawing_00_Looping: require("@/assets/animations/It_Works_Drawing_00_Looping.json"),
  It_Works_Drawing_00_No_Loop: require("@/assets/animations/It_Works_Drawing_00_No_Loop.json"),
  It_Works_Drawing_01_Looping: require("@/assets/animations/It_Works_Drawing_01_Looping.json"),
  It_Works_Drawing_01_No_Loop: require("@/assets/animations/It_Works_Drawing_01_No_Loop.json"),
  It_Works_Drawing_02_Looping: require("@/assets/animations/It_Works_Drawing_02_Looping.json"),
  It_Works_Drawing_02_No_Loop: require("@/assets/animations/It_Works_Drawing_02_No_Loop.json"),
  It_Works_Drawing_03_Looping: require("@/assets/animations/It_Works_Drawing_03_Looping.json"),
  It_Works_Drawing_03_No_Loop: require("@/assets/animations/It_Works_Drawing_03_No_Loop.json"),
  Pattern_Looping_A: require("@/assets/animations/Pattern_Looping_A.json"),
  Pattern_Looping_B: require("@/assets/animations/Pattern_Looping_B.json"),
};

export const Banner = ({ className, title, animationKey, loop, style }) => {
  const router = useRouter();
  const animationContainerRef = useRef(); // For getBoundingClientRect
  const lottiePlayerRef = useRef(); // For controlling Lottie
  const [line1Width, setLine1Width] = useState("initial");
  const [line2Width, setLine2Width] = useState("initial");
  const animationData = animations?.[animationKey];
  const disableAnimation = router.pathname === "/components";

  useEffect(() => {
    const handler = () => {
      const rect = animationContainerRef?.current?.getBoundingClientRect?.();
      setLine1Width(rect ? rect.x : "initial");
      setLine2Width(rect ? `calc(100% - ${rect.x + rect.width}px)` : "initial");
    };

    window.addEventListener("resize", handler);
    handler();

    return () => window.removeEventListener("resize", handler);
  }, []);

  useEffect(() => {
    let timeoutId;

    if (router.pathname === "/components" && lottiePlayerRef.current) {
      timeoutId = setTimeout(() => {
        lottiePlayerRef.current.stop();
      }, 4000);
    }

    return () => {
      clearTimeout(timeoutId); // clean up on unmount or route change
    };
  }, [router.pathname]);

  return (
    <div className={clsx(className, styles.banner)} style={style}>
      <div className={styles.banner__content}>
        <Container fluid="lg" className="d-flex align-items-center">
          <Row className="pt-4 pt-md-5 z-3 w-100">
            <Col xs={12} xl={8}>
              {title && (
                <h1 className="py-4 pt-md-0 mb-md-0" data-sourceflow-prop="title">
                  <span dangerouslySetInnerHTML={{ __html: title }} />
                </h1>
              )}
              <Breadcrumbs />
            </Col>
          </Row>
        </Container>
      </div>
      {animationData && !disableAnimation && (
        <div className={styles.banner__animation}>
          <div className="w-100">
            <div ref={animationContainerRef} className={clsx(styles.banner__animation__lottie, "w-100")}>
              <Lottie
                lottieRef={lottiePlayerRef}
                rendererSettings={{
                  preserveAspectRatio: "xMidYMid meet",
                  progressiveLoad: true,
                }}
                animationData={animationData}
                loop={loop}
                autoplay={!disableAnimation}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Banner;
